module.exports = __webpack_public_path__ + "static/media/cars.f8538daf.svg";